import React from "react";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import ImageGallery from "./ImageGallery";
import Campaigns from "./Campaigns";
import EditCampaign from "./Campaigns/EditCampaign";

export const Ads = () => {
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  switch (mapSideNavTabState.get()) {
    case "Image Gallery":
      return <ImageGallery />;
    case "Campaigns":
      return <Campaigns />;
    case "editCampaign":
      return <EditCampaign />;
    default:
      return <></>;
  }
};
